import $ from "jquery";
import React from 'react';
import {
  Card,
  CardHeader,
  CardText
} from 'material-ui/Card';
import config from '../../config.json';
import auth from '../../auth/auth.react.js';
import CTable from './client_table.react.js';
import CSSModules from 'react-css-modules';
import styles from './all.css';
import EditDialog from './client_edit.react.js';

const list_url = config.server + config.api_path + '/employee/clients'

class ClientAllView extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      redirect_mode: false
    }

    if (props.match && props.match.path.startsWith('/clients/edit/') &&
      Object.keys(props.match.params)
      .length > 0) {
      this.state['redirect_mode'] = true
    }
    this.load_data = this.load_data.bind(this)
    this.delete_item = this.delete_item.bind(this)
    this.edit_data = this.edit_data.bind(this)
    this.open_edit = this.open_edit.bind(this)
    this.refresh_table = this.refresh_table.bind(this)
  }

  componentDidMount() {
    if (!this.state.redirect_mode) return

    var self = this;
    const client_id = this.props.match.params.client_id
    $.get({
        dataType: 'json',
        url: list_url + '/' + client_id,
        data: auth.with_session({}),
        xhrFields: {
          withCredentials: true
        }
      })
      .done((data) => {
        var _err = data.err
        if (_err && _err.ec === 0) {
          self.edit_dialog.refs.component.open_edit(data.ret)
        } else if (_err && _err.dm === 'not_in') {
          self.props.unauthorized()
        }
      })
  }

  load_data(rowsPerPage, offset, cb) {
    var self = this;
    $.get({
        dataType: 'json',
        url: list_url,
        data: auth.with_session({
          limit: rowsPerPage,
          offset: offset
        }, true),
        xhrFields: {
          withCredentials: true
        }
      })
      .done((data) => {
        var _err = data.err
        if (_err && _err.ec === 0) {
          cb(data.ret)
        } else if (_err && _err.dm === 'not_in') {
          self.props.unauthorized()
        }
      })
  }

  open_edit(data) {
    this.edit_dialog.refs.component.open_edit(data)
  }

  edit_data(data, cb) {
    const client_id = data.id
    var self = this;
    $.ajax({
        type: 'PUT',
        dataType: 'json',
        url: list_url + '/' + client_id,
        contentType: 'application/json',
        data: auth.with_session({
          name: data.name,
        }),
        xhrFields: {
          withCredentials: true
        }
      })
      .done((_data) => {
        var _err = _data.err
        if (_err && _err.ec === 0) {
          self.refresh_table()
          cb(null)
        } else if (_err && _err.dm === 'not_in') {
          self.props.unauthorized()
        } else if (_err) {
          cb(new Error(_err.em))
        }
      })
  }

  delete_item(data, cb) {
    console.log('deleting client', data)
    cb()
  }

  refresh_table() {
    this.table.refresh()
  }

  render() {
    return (
      <Card styleName="wrapper">
        <CardHeader
          title="All Clients"
          actAsExpander={false}
          showExpandableButton={false}
        />
        <CardText styleName="cli-card">
          <EditDialog
            ref={(dialog) => {this.edit_dialog = dialog}}
            submit_edit={this.edit_data}
            history={this.props.history}
          >
          </EditDialog>
          <CTable
            ref={(table) => {this.table = table}}
            open_edit={this.open_edit}
            load_clients={this.load_data}
            delete_client={this.delete_item}
          >
          </CTable>
        </CardText>
      </Card>
    )
  }
}

ClientAllView.defaultProps = {
  data: []
}

export default CSSModules(ClientAllView, styles)



// WEBPACK FOOTER //
// ./src/views/clients/all.react.js